import React from 'react';
import { Carousel } from '../../components/Carousel';
import { CarouselProps } from '../../components/Carousel/type';
import { classNames } from '../../utils/style';
import { ButtonV2Props } from '../../components/ButtonV2';

export interface TestimonialLayoutProps extends CarouselProps {
  title?: string;
  buttons?: ButtonV2Props[];
  subtitle?: string;
  id?: string;
  titleAs?: 'h1' | 'h2' | 'h3';
  subtitleAs?: 'h2' | 'h3' | 'p' | 'div';
  className?: string;
}

export const TestimonialLayout = ({
  isDark,
  isLoop,
  className,
  children,
}: TestimonialLayoutProps) => {
  return (
    <Carousel
      isItemsCentered={true}
      {...{
        isDark,
        isLoop,
        className: classNames(className, 'TestimonialLayoutCarousel'),
      }}
    >
      {children}
    </Carousel>
  );
};
